<template>
  <div class="my-dialog" v-show="dialogVisible" @click="dialogVisible = false">
    <div class="content" @click.stop>
      <h2>{{ this.type != "new" ? $t("app.edit") : $t("app.new") }}</h2>
      <div class="template-content">
        <el-row>
          <el-col :span="2">{{ $t("app.templateCode") }}:</el-col>
          <el-col :span="10">
            <el-input
              size="small"
              v-model="code"
              :disabled="type === 'edit'"
              :placeholder="$t('app.templateCode')"
              style="margin-bottom: 15px; width: 200px"
            >
            </el-input>
          </el-col>
          <el-col :span="2">{{ $t("app.templateName") }}:</el-col>
          <el-col :span="10">
            <el-input
              size="small"
              v-model="name"
              :placeholder="$t('app.templateName')"
              style="margin-bottom: 15px; width: 200px"
            >
            </el-input>
          </el-col>
          <el-col :span="2"> {{ $t("app.addressee") }}: </el-col>
          <el-col :span="22">
            <el-input
              size="small"
              v-model="addressee"
              :placeholder="$t('app.addressee')"
              style="margin-bottom: 15px"
            >
            </el-input>
          </el-col>
          <el-col :span="2"> {{ $t("app.CC") }}: </el-col>
          <el-col :span="22">
            <el-input
              size="small"
              v-model="cc"
              :placeholder="$t('app.CC')"
              style="margin-bottom: 15px"
            >
            </el-input>
          </el-col>
          <el-col :span="2"> {{ $t("app.bcc") }}: </el-col>
          <el-col :span="22">
            <el-input
              size="small"
              v-model="bcc"
              :placeholder="$t('app.bcc')"
              style="margin-bottom: 15px"
            >
            </el-input>
          </el-col>
          <el-col :span="2"> {{ $t("app.theme") }}:</el-col>
          <el-col :span="22">
            <el-input
              size="small"
              v-model="theme"
              :placeholder="$t('app.theme')"
              style="margin-bottom: 15px"
            >
            </el-input>
          </el-col>
          <!-- <el-col :span="2"> {{ $t("app.content") }}: </el-col>
          <el-col :span="22" style="margin-bottom: 15px">
            <el-cascader
              @focus="getIndex"
              v-model="value"
              size="small"
              :options="options"
              :props="{ expandTrigger: 'hover' }"
              @change="handleChange"
              :placeholder="$t('app.macroInsert')"
            ></el-cascader>
          </el-col> -->
          <el-col :span="2"> 附件: </el-col>
          <el-col :span="22" style="margin-bottom: 15px">
            <el-upload
              class="upload-demo"
              :action="uploadUrl"
              :on-success="handleSuccess"
              :on-remove="handleRemove"
              :on-error="handleErr"
              :before-upload="beforeUpload"
              :before-remove="beforeRemove"
              multiple
              :file-list="fileList"
            >
              <el-button size="small" type="primary">點擊上傳</el-button>
              <div slot="tip" class="el-upload__tip">不超過2mb</div>
            </el-upload>
          </el-col>
        </el-row>
        <div style="border: 1px solid #ccc">
          <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
          />
          <Editor
            style="height: 500px; overflow-y: hidden"
            v-model="html"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="onCreated"
          />
        </div>
      </div>
      <span class="dialog-footer">
        <el-button size="small" type="info" @click="dialogVisible = false">{{
          $t("app.cancel")
        }}</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          @click="handleClose"
          >{{ $t("app.confirm") }}</el-button
        >
      </span>
    </div>
  </div>
</template>
<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import {
  addTemplate,
  updateTemplate,
} from "@/api/systemManagement/templateManagement";
import { formatDate } from "@/utils/utils.js";
import { url } from "@/utils/request";
export default {
  components: {
    //使用编辑器
    Editor,
    Toolbar,
  },
  data() {
    return {
      html: "",
      editor: null,
      toolbarConfig: {},
      editorConfig: { placeholder: "请输入内容..." },
      mode: "default", // or 'simple'
      fileList: [],
      uploadUrl: url + "/CheckOutApplication/UploadFile",
      value: [],
      options: [
        {
          value: "1",
          label: this.$t("app.template.name_address_un"),
          children: [
            {
              value: "_FoxCURSOR",
              label: this.$t("app.template.cursor"),
            },
            {
              value: "_FoxQUOTES",
              label: this.$t("app.template.quotes"),
            },
            {
              value: "_FoxTEXT",
              label: this.$t("app.template.text"),
            },
            {
              value: "_FoxDATE",
              label: this.$t("app.template.date"),
            },
            {
              value: "_FoxTIME",
              label: this.$t("app.template.time"),
            },
            {
              value: "_FoxODATE",
              label: this.$t("app.template.oDate"),
            },
            {
              value: "_FoxOTIME",
              label: this.$t("app.template.oTime"),
            },
            {
              value: "_FoxOSUBJ",
              label: this.$t("app.template.oSubject"),
            },
            {
              value: "_FoxATTACHLIST",
              label: this.$t("app.template.attachList"),
            },
            {
              value: "_FoxONoCONTENT",
              label: this.$t("app.template.onoContent"),
            },
          ],
        },
        {
          value: "2",
          label: this.$t("app.template.sender"),
          children: [
            {
              value: "_FoxFROMNAME",
              label: this.$t("app.template.fromName"),
            },
            {
              value: "_FoxREPLYNAME",
              label: this.$t("app.template.replyName"),
            },
            {
              value: "_FoxFROMADDR",
              label: this.$t("app.template.fromAddr"),
            },
            {
              value: "_FoxREPLYADDR",
              label: this.$t("app.template.replyAddr"),
            },
            {
              value: "_FoxOFROMNAME",
              label: this.$t("app.template.oFromName"),
            },
            {
              value: "_FoxOREPLYNAME",
              label: this.$t("app.template.oReplyName"),
            },
            {
              value: "_FoxOFROMADDR",
              label: this.$t("app.template.oFromAddr"),
            },
            {
              value: "_FoxOREPLYADDR",
              label: this.$t("app.template.oReplyAddr"),
            },
          ],
        },
        {
          value: "3",
          label: this.$t("app.template.recipients"),
          children: [
            {
              value: "_FoxTONAME",
              label: this.$t("app.template.toName"),
            },
            {
              value: "_FoxTOADDR",
              label: this.$t("app.template.toAddr"),
            },
            {
              value: "_FoxOTONAME",
              label: this.$t("app.template.oToName"),
            },
            {
              value: "_FoxOTOADDR",
              label: this.$t("app.template.oToAddr"),
            },
            {
              value: "_FoxOCCNAME",
              label: this.$t("app.template.OccName"),
            },
            {
              value: "_FoxOCCADDR",
              label: this.$t("app.template.OccAddr"),
            },
          ],
        },
        {
          value: "4",
          label: this.$t("app.template.topic"),
          children: [
            {
              value: "1",
              label: this.$t("app.template.sDate"),
            },
            {
              value: "2",
              label: this.$t("app.template.sTime"),
            },
          ],
        },
      ],
      loading: false,
      dialogVisible: false,
      type: "new",
      code: "",
      name: "",
      content: "",
      addressee: "",
      cc: "",
      bcc: "",
      theme: "",
      index: "",
      cursorIndex: "",
    };
  },
  computed: {},
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    beforeDestroy() {
      const editor = this.editor;
      if (editor == null) return;
      editor.destroy(); // 组件销毁时，及时销毁编辑器
    },
    handleSuccess(event, file, fileList) {
      this.fileList = fileList.map((i) => {
        return {
          name: i.name,
          url: i.url || i.response.data.Url,
        };
      });
    },
    handleRemove(file, fileList) {
      this.fileList = fileList.map((i) => {
        return {
          name: i.name,
          url: i.url || i.response.data.Url,
        };
      });
    },
    handleErr() {
      this.$message.error("上傳失敗，請重試");
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return false;
      }
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    getIndex() {
      const range = this.$refs.quillEditor.quill.getSelection();
      this.cursorIndex = range ? range.index : 0;
    },
    handleChange() {
      if (this.value.length >= 1) {
        if (this.value[0] === "4") {
          if (this.value[1] === "1") {
            this.theme += formatDate(new Date(), "yyyy/MM/dd");
          } else {
            this.theme += formatDate(new Date(), "hh:mm:ss");
          }
          this.value = [];
          return;
        }
        this.value = [];
      }
    },
    new() {
      this.dialogVisible = true;
      this.type = "new";
      this.code = "";
      this.name = "";
      this.content = "";
      this.addressee = "";
      this.cc = "";
      this.bcc = "";
      this.theme = "";
      this.html = "";
    },
    edit(index, row) {
      this.dialogVisible = true;
      this.index = index;
      this.type = "edit";
      this.code = row.code;
      this.name = row.name;
      this.content = row.content;
      this.html = row.content;
      this.addressee = row.addressee;
      this.cc = row.cc;
      this.bcc = row.bcc;
      this.theme = row.theme;
    },
    handleClose() {
      this.$confirm(
        (this.type === "edit"
          ? this.$t("app.confirmModification")
          : this.$t("app.confirmAdd")) + "?"
      ).then(() => {
        this.loading = true;
        if (this.type === "new") {
          addTemplate({
            TemplateCode: this.code,
            TemplateName: this.name,
            ToUser: this.addressee,
            CCUser: this.cc,
            BCCUser: this.bcc,
            Subject: this.theme,
            Content: this.html,
            UploadSupportingDocument: this.fileList.map((_) => {
              return {
                Name: _.name,
                Url: _.url,
              };
            }),
          })
            .then(() => {
              this.loading = false;
              this.success();
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          updateTemplate({
            TemplateCode: this.code,
            TemplateName: this.name,
            ToUser: this.addressee,
            CCUser: this.cc,
            BCCUser: this.bcc,
            Subject: this.theme,
            Content: this.html,
            UploadSupportingDocument: this.fileList.map((_) => {
              return {
                Name: _.name,
                Url: _.url,
              };
            }),
          })
            .then(() => {
              this.loading = false;
              this.success();
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    success() {
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success",
      });
      this.dialogVisible = false;
      if (this.type === "edit") {
        this.$emit("handleEdit", this.index, {
          code: this.code,
          name: this.name,
          content: this.html,
          addressee: this.addressee,
          cc: this.cc,
          bcc: this.bcc,
          theme: this.theme,
        });
        return;
      }
      this.$emit("handleAdd", {
        code: this.code,
        name: this.name,
        content: this.html,
        addressee: this.addressee,
        cc: this.cc,
        bcc: this.bcc,
        theme: this.theme,
      });
    },
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
.my-dialog {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding-top: 40px;
  z-index: 1000;
  background-color: rgba($color: #000000, $alpha: 0.3);
  .content {
    height: 70%;
    position: relative;
    width: 900px;
    margin: 0 auto;
    padding: 20px;
    border-radius: 8px;
    background-color: #fff;
    padding-bottom: 90px;
    .template-content {
      height: 100%;
      overflow: auto;
    }
    h2 {
      margin-bottom: 10px;
    }
    .dialog-footer {
      position: absolute;
      right: 20px;
      bottom: 10px;
    }
  }
}
</style>
